import { useState } from 'react';

import { InputType } from '../types';

export type UseHiddenProps = {
  type: InputType;
  initialHidden?: boolean
};

export const useHidden = ({ type, initialHidden }: UseHiddenProps) => {
  const [isHidden, setIsHidden] = useState(type === 'password' || Boolean(initialHidden));

  const hide = () => {
    setIsHidden(true);
  };

  const reveal = () => {
    setIsHidden(false);
  };

  return { isHidden, hide, reveal };
};
